/**
 * Entity 싱크 변경 이력 조회 캐시 — 같은 entity 에 대해 여러 섹션 배너가 동시에 호출해도
 * 한 번만 네트워크 요청하도록 in-flight dedup + 짧은 TTL 캐시.
 *
 * 설계 의도: 섹션 본 데이터와 분리된 비동기 조회(client_cd+entity_cd)를 가볍게 유지.
 */
import { entityMyApi } from '../api/entityApi';

const TTL_MS = 15_000;

interface CacheEntry {
    at: number;
    promise: Promise<any>;
}

const cache = new Map<string, CacheEntry>();

/** 캐시(또는 in-flight) 재사용하여 sync history 조회 */
export function fetchSyncHistoryCached(entityCd: string): Promise<any> {
    const key = String(entityCd || '').trim();
    if (!key) return Promise.resolve({ history: [] });

    const now = Date.now();
    const hit = cache.get(key);
    if (hit && now - hit.at < TTL_MS) {
        return hit.promise;
    }

    const promise = entityMyApi
        .getEntitySyncHistory(key)
        .catch((e) => {
            // 실패는 캐시하지 않음 (다음 호출 재시도)
            cache.delete(key);
            throw e;
        });
    cache.set(key, { at: now, promise });
    return promise;
}

/** 싱크 실행/데이터 변경 후 강제 무효화 */
export function invalidateSyncHistory(entityCd?: string): void {
    if (entityCd) cache.delete(String(entityCd).trim());
    else cache.clear();
}
